var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70717 5.76572C8.8573 5.88582 8.8573 6.11415 8.70717 6.23425L4.48741 9.61006C4.29098 9.7672 4 9.62735 4 9.3758L4 2.62417C4 2.37262 4.29098 2.23277 4.48741 2.38991L8.70717 5.76572Z",
    fill: "#4E5969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayLeft);
export default __webpack_public_path__ + "static/media/gray-left.3ffd2589b6537755d63df621d358e2d3.svg";
export { ForwardRef as ReactComponent };